import axios from 'axios'

export default class Anexo {
  constructor(tokenBearer, url, id) {
    this.url = url
    this.tokenBearer = tokenBearer
    this.id = id
  }

  getAllAnexo(args = '') {
    let url = `${this.url}/api/unimed/anexo?${args}`

    return new Promise(async (resolve, reject) => {
      let optionsAnexo = { method: 'get', url, headers: { Authorization: this.tokenBearer } }

      try {
        const responseAnexo = await axios(optionsAnexo)
        resolve(responseAnexo)
      } catch (err) {
        reject(err)
      }
    })
  }

  getAnexo(args = '') {
    let url = `${this.url}/api/unimed/anexo/${this.id}?${args}`

    return new Promise(async (resolve, reject) => {
      let optionsAnexo = {
        method: 'get',
        url,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let responseAnexo = await axios(optionsAnexo)
        resolve(responseAnexo)
      } catch (err) {
        reject(err)
      }
    })
  }

  putAnexo(data) {
    return new Promise(async (resolve, reject) => {
      let optionsAnexo = {
        method: 'put',
        url: `${this.url}/api/unimed/anexo/${this.id}`,
        headers: {
          Authorization: this.tokenBearer,
          'Content-Type': 'multipart/form-data'
        },
        data: data
      }

      try {
        let responseAnexo = await axios(optionsAnexo)
        resolve(responseAnexo)
      } catch (err) {
        reject(err)
      }
    })
  }

  exportarGrid(args) {
    let url = `${this.url}/api/unimed/anexo/exportar?${args}`

    return new Promise(async (resolve, reject) => {
      let optionsAnexo = {
        method: 'get',
        url,
        headers: { Authorization: this.tokenBearer },
        responseType: 'blob'
      }
      try {
        let response = await axios(optionsAnexo)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  exportarAnexo(url) {
    return new Promise(async (resolve, reject) => {
      let optionsAnexo = {
        method: 'get',
        url,
        headers: { Authorization: this.tokenBearer },
        responseType: 'blob'
      }
      try {
        let response = await axios(optionsAnexo)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  exportarMultiplosAnexos(uuids) {
    let url = `${this.url}/api/arquivos/zip/${uuids}`

    return new Promise(async (resolve, reject) => {
      let optionsAnexo = {
        method: 'get',
        url,
        headers: { Authorization: this.tokenBearer },
        responseType: 'blob'
      }
      try {
        let response = await axios(optionsAnexo)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  download(args = '') {
    let url = `${this.url}/api/unimed/anexo/exportar/${this.id}?${args}`

    return new Promise(async (resolve, reject) => {
      let optionsAnexo = {
        method: 'get',
        url: url,
        headers: {
          Authorization: this.tokenBearer
        },
        responseType: 'blob'
      }

      try {
        let response = await axios(optionsAnexo)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  deleteAnexo(versaoUnimedId) {
    let url = `${this.url}/api/unimed/anexo/${versaoUnimedId}/${this.id}`

    return new Promise(async (resolve, reject) => {
      let optionsAnexo = { method: 'delete', url, headers: { Authorization: this.tokenBearer } }

      try {
        let responseAnexo = await axios(optionsAnexo)
        resolve(responseAnexo)
      } catch (err) {
        reject(err)
      }
    })
  }

  deleteAnexoVersaoTemp(unimedId) {
    let url = `${this.url}/api/unimed/anexo/versaoTemp/${unimedId}/${this.id}`

    return new Promise(async (resolve, reject) => {
      let optionsAnexo = { method: 'delete', url, headers: { Authorization: this.tokenBearer } }

      try {
        let responseAnexo = await axios(optionsAnexo)
        resolve(responseAnexo)
      } catch (err) {
        reject(err)
      }
    })
  }
}
